export default __webpack_public_path__ + "static/media/message.a503269c.png";